import { TabProps } from "shared/types";
import { WidgetDetailsTabEnum } from "../../WidgetDetailsTabEnum";
import { TFunction } from "i18next";

export const getWidgetDetailsTabsConfig = (
  t: TFunction<"translation", undefined>,
) => {
  const config: TabProps[] = [
    {
      value: WidgetDetailsTabEnum.WidgetItems,
      title: t(`widgets:DETAILS.TABS.${WidgetDetailsTabEnum.WidgetItems}`),
    },
    {
      value: WidgetDetailsTabEnum.Setup,
      title: t(`widgets:DETAILS.TABS.${WidgetDetailsTabEnum.Setup}`),
    },
    {
      value: WidgetDetailsTabEnum.Details,
      title: t(`widgets:DETAILS.TABS.${WidgetDetailsTabEnum.Details}`),
    },
    {
      value: WidgetDetailsTabEnum.Notes,
      title: t(`widgets:DETAILS.TABS.${WidgetDetailsTabEnum.Notes}`),
    },
  ];

  return config;
};
